var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"width":_vm.width,"src":"/wp-content/themes/genesis-go2roues/svg/Spinner-1s-200px.svg","alt":"spinner"}})])}
var staticRenderFns = []

export { render, staticRenderFns }